// src/pages/Platform/Chatbot/ChatbotWidget/ProactiveBubble.js
// Proactive chat bubble with toggle switch

import React from 'react';

function ProactiveBubble({
    message,
    onDismiss,
    onAccept,
    onToggleOff,
    position = 'right',
    isVisible = false,
    suggestionsEnabled = true,
    isPlatform = false
}) {
    // If suggestions are disabled or not visible, don't render anything
    if (!suggestionsEnabled || !isVisible || !message) {
        return null;
    }

    const handleClick = () => {
        if (onAccept) {
            onAccept(message);
        }
    };

    const handleDismiss = (e) => {
        e.stopPropagation();
        if (onDismiss) {
            onDismiss();
        }
    };

    const handleToggle = (e) => {
        e.stopPropagation();
        if (onToggleOff) {
            onToggleOff();
        }
    };

    return (
        <div className={`proactive-bubble-wrapper ${position} ${isPlatform ? 'platform' : 'iframe'}`}>
            <div className="proactive-bubble">
                {/* Main message */}
                <div
                    className="proactive-bubble-content"
                    onClick={handleClick}
                    role="button"
                    tabIndex={0}
                    onKeyPress={(e) => e.key === 'Enter' && handleClick()}
                    aria-label="Click to ask this question"
                >
                    <span className="proactive-bubble-text">{message}</span>
                </div>
                {/* Bottom toggle control */}
                <div className="proactive-bubble-header" onClick={(e) => e.stopPropagation()}>
                    <span className="proactive-bubble-toggle-label">Turn off suggestions</span>
                    <label className="proactive-bubble-toggle">
                        <input
                            type="checkbox"
                            checked={suggestionsEnabled}
                            onChange={handleToggle}
                            aria-label="Toggle suggestions"
                        />
                        <span className="toggle-slider"></span>
                    </label>
                </div>
            </div>
            <button
                className="proactive-bubble-close"
                onClick={handleDismiss}
                aria-label="Dismiss"
            >
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
        </div>
    );
}

export default ProactiveBubble;




